import type { Customer } from '../types';

export const initialCustomers: Customer[] = [
    { id: 1, name: 'Alice Johnson', phone: '021 123 4567', email: 'alice.j@example.com', loyaltyPoints: 150, notes: 'Loves the window seat.' },
    { id: 2, name: 'Bob Williams', phone: '027 987 6543', email: 'b.williams@example.com', loyaltyPoints: 45 },
    { id: 3, name: 'Charlie Brown', phone: '022 555 8888', email: 'charlie@example.com', loyaltyPoints: 320, notes: 'Allergic to peanuts.' },
    { id: 4, name: 'Diana Miller', phone: '021 234 5678', email: 'diana.m@example.com', loyaltyPoints: 800 },
];
